// components
import GridPageAbstract from '../../GridPageAbstract';
import config from '../../../config';
import { ReceiveSquare2BulkIcon } from '../../../icons-lib/bulkIcons';

export default class FeeTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'feeTransactions';
        this.Server = this.props.context.getState().server.feeTransactions;

        this.headerStartIcon = ReceiveSquare2BulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.hiddenColumns = config?.hiddenColumns?.feeTransactions || [];

        this.Head = [
            {
                id: 'id',
                label: 'id',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'partnerAccount',
                label: 'partnerAccount',
                object: 'partnerAccount',
                alignRight: false,
                cell: 'Select',
                from: 'partnerAccounts',
                display: 'name'
            },
            {
                id: 'wallet',
                label: 'walletNumber',
                display: 'walletNumber',
                alignRight: false,
                cell: 'Select',
                object: 'wallet',
                from: 'wallets'
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: false,
                cell: 'Amount'
            },
            {
                id: 'feeType',
                label: 'feeType',
                alignRight: false,
                cell: 'Items',
                items: ['storage_fee']
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
